const DIRECTORY_USER_LIST_CACHE_ID = 'DirectoryUserList';

export {DIRECTORY_USER_LIST_CACHE_ID};
